(function ($) {
    //sidebar menu functionality
    jQuery(document).ready(function () {
        //fire up foundation
        jQuery(document).foundation();

        //include slideout menu
        !(function (t) {
            if ("object" == typeof exports && "undefined" != typeof module)
                module.exports = t();
            else if ("function" == typeof define && define.amd) define([], t);
            else {
                var e;
                "undefined" != typeof window
                    ? (e = window)
                    : "undefined" != typeof global
                    ? (e = global)
                    : "undefined" != typeof self && (e = self),
                    (e.Slideout = t());
            }
        })(function () {
            var t, e, n;
            return (function i(t, e, n) {
                function o(r, a) {
                    if (!e[r]) {
                        if (!t[r]) {
                            var u = typeof require == "function" && require;
                            if (!a && u) return u(r, !0);
                            if (s) return s(r, !0);
                            var l = new Error("Cannot find module '" + r + "'");
                            throw ((l.code = "MODULE_NOT_FOUND"), l);
                        }
                        var f = (e[r] = { exports: {} });
                        t[r][0].call(
                            f.exports,
                            function (e) {
                                var n = t[r][1][e];
                                return o(n ? n : e);
                            },
                            f,
                            f.exports,
                            i,
                            t,
                            e,
                            n
                        );
                    }
                    return e[r].exports;
                }
                var s = typeof require == "function" && require;
                for (var r = 0; r < n.length; r++) o(n[r]);
                return o;
            })(
                {
                    1: [
                        function (t, e, n) {
                            "use strict";
                            var i = t("decouple");
                            var o = t("emitter");
                            var s;
                            var r = false;
                            var a = window.document;
                            var u = a.documentElement;
                            var l = window.navigator.msPointerEnabled;
                            var f = {
                                start: l ? "MSPointerDown" : "touchstart",
                                move: l ? "MSPointerMove" : "touchmove",
                                end: l ? "MSPointerUp" : "touchend",
                            };
                            var h = (function v() {
                                var t = /^(Webkit|Khtml|Moz|ms|O)(?=[A-Z])/;
                                var e =
                                    a.getElementsByTagName("script")[0].style;
                                for (var n in e) {
                                    if (t.test(n)) {
                                        return (
                                            "-" +
                                            n.match(t)[0].toLowerCase() +
                                            "-"
                                        );
                                    }
                                }
                                if ("WebkitOpacity" in e) {
                                    return "-webkit-";
                                }
                                if ("KhtmlOpacity" in e) {
                                    return "-khtml-";
                                }
                                return "";
                            })();
                            function c(t, e) {
                                for (var n in e) {
                                    if (e[n]) {
                                        t[n] = e[n];
                                    }
                                }
                                return t;
                            }
                            function p(t, e) {
                                t.prototype = c(t.prototype || {}, e.prototype);
                            }
                            function d(t) {
                                while (t.parentNode) {
                                    if (
                                        t.getAttribute(
                                            "data-slideout-ignore"
                                        ) !== null
                                    ) {
                                        return t;
                                    }
                                    t = t.parentNode;
                                }
                                return null;
                            }
                            function _(t) {
                                t = t || {};
                                this._startOffsetX = 0;
                                this._currentOffsetX = 0;
                                this._opening = false;
                                this._moved = false;
                                this._opened = false;
                                this._preventOpen = false;
                                this._touch =
                                    t.touch === undefined
                                        ? true
                                        : t.touch && true;
                                this._side = t.side || "left";
                                this.panel = t.panel;
                                this.menu = t.menu;
                                if (
                                    !this.panel.classList.contains(
                                        "slideout-panel"
                                    )
                                ) {
                                    this.panel.classList.add("slideout-panel");
                                }
                                if (
                                    !this.panel.classList.contains(
                                        "slideout-panel-" + this._side
                                    )
                                ) {
                                    this.panel.classList.add(
                                        "slideout-panel-" + this._side
                                    );
                                }
                                if (
                                    !this.menu.classList.contains(
                                        "slideout-menu"
                                    )
                                ) {
                                    this.menu.classList.add("slideout-menu");
                                }
                                if (
                                    !this.menu.classList.contains(
                                        "slideout-menu-" + this._side
                                    )
                                ) {
                                    this.menu.classList.add(
                                        "slideout-menu-" + this._side
                                    );
                                }
                                this._fx = t.fx || "ease";
                                this._duration =
                                    parseInt(t.duration, 10) || 300;
                                this._tolerance =
                                    parseInt(t.tolerance, 10) || 70;
                                this._padding = this._translateTo =
                                    parseInt(t.padding, 10) || 256;
                                this._orientation =
                                    this._side === "right" ? -1 : 1;
                                this._translateTo *= this._orientation;
                                if (this._touch) {
                                    this._initTouchEvents();
                                }
                            }
                            p(_, o);
                            _.prototype.open = function () {
                                var t = this;
                                this.emit("beforeopen");
                                if (!u.classList.contains("slideout-open")) {
                                    u.classList.add("slideout-open");
                                }
                                this._setTransition();
                                this._translateXTo(this._translateTo);
                                this._opened = true;
                                setTimeout(function () {
                                    t.panel.style.transition = t.panel.style[
                                        "-webkit-transition"
                                    ] = "";
                                    t.emit("open");
                                }, this._duration + 50);
                                return this;
                            };
                            _.prototype.close = function () {
                                var t = this;
                                if (!this.isOpen() && !this._opening) {
                                    return this;
                                }
                                this.emit("beforeclose");
                                this._setTransition();
                                this._translateXTo(0);
                                this._opened = false;
                                setTimeout(function () {
                                    u.classList.remove("slideout-open");
                                    t.panel.style.transition =
                                        t.panel.style["-webkit-transition"] =
                                        t.panel.style[h + "transform"] =
                                        t.panel.style.transform =
                                            "";
                                    t.emit("close");
                                }, this._duration + 50);
                                return this;
                            };
                            _.prototype.toggle = function () {
                                return this.isOpen()
                                    ? this.close()
                                    : this.open();
                            };
                            _.prototype.isOpen = function () {
                                return this._opened;
                            };
                            _.prototype._translateXTo = function (t) {
                                this._currentOffsetX = t;
                                this.panel.style[h + "transform"] =
                                    this.panel.style.transform =
                                        "translateX(" + t + "px)";
                                return this;
                            };
                            _.prototype._setTransition = function () {
                                this.panel.style[h + "transition"] =
                                    this.panel.style.transition =
                                        h +
                                        "transform " +
                                        this._duration +
                                        "ms " +
                                        this._fx;
                                return this;
                            };
                            _.prototype._initTouchEvents = function () {
                                var t = this;
                                this._onScrollFn = i(a, "scroll", function () {
                                    if (!t._moved) {
                                        clearTimeout(s);
                                        r = true;
                                        s = setTimeout(function () {
                                            r = false;
                                        }, 250);
                                    }
                                });
                                this._preventMove = function (e) {
                                    if (t._moved) {
                                        e.preventDefault();
                                    }
                                };
                                a.addEventListener(f.move, this._preventMove);
                                this._resetTouchFn = function (e) {
                                    if (typeof e.touches === "undefined") {
                                        return;
                                    }
                                    t._moved = false;
                                    t._opening = false;
                                    t._startOffsetX = e.touches[0].pageX;
                                    t._preventOpen =
                                        !t._touch ||
                                        (!t.isOpen() &&
                                            t.menu.clientWidth !== 0);
                                };
                                this.panel.addEventListener(
                                    f.start,
                                    this._resetTouchFn
                                );
                                this._onTouchCancelFn = function () {
                                    t._moved = false;
                                    t._opening = false;
                                };
                                this.panel.addEventListener(
                                    "touchcancel",
                                    this._onTouchCancelFn
                                );
                                this._onTouchEndFn = function () {
                                    if (t._moved) {
                                        t.emit("translateend");
                                        t._opening &&
                                        Math.abs(t._currentOffsetX) >
                                            t._tolerance
                                            ? t.open()
                                            : t.close();
                                    }
                                    t._moved = false;
                                };
                                this.panel.addEventListener(
                                    f.end,
                                    this._onTouchEndFn
                                );
                                this._onTouchMoveFn = function (e) {
                                    if (
                                        r ||
                                        t._preventOpen ||
                                        typeof e.touches === "undefined" ||
                                        d(e.target)
                                    ) {
                                        return;
                                    }
                                    var n =
                                        e.touches[0].clientX - t._startOffsetX;
                                    var i = (t._currentOffsetX = n);
                                    if (Math.abs(i) > t._padding) {
                                        return;
                                    }
                                    if (Math.abs(n) > 20) {
                                        t._opening = true;
                                        var o = n * t._orientation;
                                        if (
                                            (t._opened && o > 0) ||
                                            (!t._opened && o < 0)
                                        ) {
                                            return;
                                        }
                                        if (!t._moved) {
                                            t.emit("translatestart");
                                        }
                                        if (o <= 0) {
                                            i = n + t._padding * t._orientation;
                                            t._opening = false;
                                        }
                                        if (
                                            !(
                                                t._moved &&
                                                u.classList.contains(
                                                    "slideout-open"
                                                )
                                            )
                                        ) {
                                            u.classList.add("slideout-open");
                                        }
                                        t.panel.style[h + "transform"] =
                                            t.panel.style.transform =
                                                "translateX(" + i + "px)";
                                        t.emit("translate", i);
                                        t._moved = true;
                                    }
                                };
                                this.panel.addEventListener(
                                    f.move,
                                    this._onTouchMoveFn
                                );
                                return this;
                            };
                            _.prototype.enableTouch = function () {
                                this._touch = true;
                                return this;
                            };
                            _.prototype.disableTouch = function () {
                                this._touch = false;
                                return this;
                            };
                            _.prototype.destroy = function () {
                                this.close();
                                a.removeEventListener(
                                    f.move,
                                    this._preventMove
                                );
                                this.panel.removeEventListener(
                                    f.start,
                                    this._resetTouchFn
                                );
                                this.panel.removeEventListener(
                                    "touchcancel",
                                    this._onTouchCancelFn
                                );
                                this.panel.removeEventListener(
                                    f.end,
                                    this._onTouchEndFn
                                );
                                this.panel.removeEventListener(
                                    f.move,
                                    this._onTouchMoveFn
                                );
                                a.removeEventListener(
                                    "scroll",
                                    this._onScrollFn
                                );
                                this.open = this.close = function () {};
                                return this;
                            };
                            e.exports = _;
                        },
                        { decouple: 2, emitter: 3 },
                    ],
                    2: [
                        function (t, e, n) {
                            "use strict";
                            var i = (function () {
                                return (
                                    window.requestAnimationFrame ||
                                    window.webkitRequestAnimationFrame ||
                                    function (t) {
                                        window.setTimeout(t, 1e3 / 60);
                                    }
                                );
                            })();
                            function o(t, e, n) {
                                var o,
                                    s = false;
                                function r(t) {
                                    o = t;
                                    a();
                                }
                                function a() {
                                    if (!s) {
                                        i(u);
                                        s = true;
                                    }
                                }
                                function u() {
                                    n.call(t, o);
                                    s = false;
                                }
                                t.addEventListener(e, r, false);
                                return r;
                            }
                            e.exports = o;
                        },
                        {},
                    ],
                    3: [
                        function (t, e, n) {
                            "use strict";
                            var i = function (t, e) {
                                if (!(t instanceof e)) {
                                    throw new TypeError(
                                        "Cannot call a class as a function"
                                    );
                                }
                            };
                            n.__esModule = true;
                            var o = (function () {
                                function t() {
                                    i(this, t);
                                }
                                t.prototype.on = function e(t, n) {
                                    this._eventCollection =
                                        this._eventCollection || {};
                                    this._eventCollection[t] =
                                        this._eventCollection[t] || [];
                                    this._eventCollection[t].push(n);
                                    return this;
                                };
                                t.prototype.once = function n(t, e) {
                                    var n = this;
                                    function i() {
                                        n.off(t, i);
                                        e.apply(this, arguments);
                                    }
                                    i.listener = e;
                                    this.on(t, i);
                                    return this;
                                };
                                t.prototype.off = function o(t, e) {
                                    var n = undefined;
                                    if (
                                        !this._eventCollection ||
                                        !(n = this._eventCollection[t])
                                    ) {
                                        return this;
                                    }
                                    n.forEach(function (t, i) {
                                        if (t === e || t.listener === e) {
                                            n.splice(i, 1);
                                        }
                                    });
                                    if (n.length === 0) {
                                        delete this._eventCollection[t];
                                    }
                                    return this;
                                };
                                t.prototype.emit = function s(t) {
                                    var e = this;
                                    for (
                                        var n = arguments.length,
                                            i = Array(n > 1 ? n - 1 : 0),
                                            o = 1;
                                        o < n;
                                        o++
                                    ) {
                                        i[o - 1] = arguments[o];
                                    }
                                    var s = undefined;
                                    if (
                                        !this._eventCollection ||
                                        !(s = this._eventCollection[t])
                                    ) {
                                        return this;
                                    }
                                    s = s.slice(0);
                                    s.forEach(function (t) {
                                        return t.apply(e, i);
                                    });
                                    return this;
                                };
                                return t;
                            })();
                            n["default"] = o;
                            e.exports = n["default"];
                        },
                        {},
                    ],
                },
                {},
                [1]
            )(1);
        });

        var slideout = new Slideout({
            panel: document.getElementById("panel"),
            menu: document.getElementById("menu"),
            padding: 256,
            side: "right",
            tolerance: 70,
        });

        // Toggle button
        document
            .querySelector(".js-slideout-toggle")
            .addEventListener("click", function () {
                slideout.toggle();
            });

        document
            .querySelector(".slideout-menu .close-button")
            .addEventListener("click", function () {
                slideout.toggle();
            });

        //prepare mobile menu arrows
        $("#mobile-menu li").each(function (index, element) {
            var classes = $(this).attr("class");

            //add arrows to elements with children
            if (classes.indexOf("menu-item-has-children") >= 0) {
                $(this).prepend('<i class="arrow"> </i>');
            }
        });

        //click functionality
        $(document).on(
            "click touchend",
            "#mobile-menu > .menu-item-has-children > a, #mobile-menu > .menu-item-has-children > i",
            function (e) {
                if (
                    $("#mobile-menu > .menu-item-has-children").hasClass(
                        "showing-ul"
                    )
                ) {
                    //exclude this element
                    var myParent = $(this).closest(
                        "#mobile-menu > .menu-item-has-children"
                    );
                    $("#mobile-menu > .menu-item-has-children")
                        .not(myParent)
                        .removeClass("showing-ul")
                        .children(".sub-menu")
                        .slideUp();
                }

                //show signling
                if ($(this).parent().hasClass("showing-ul")) {
                    $(this).siblings(".sub-menu").slideUp();
                    $(this).parent().removeClass("showing-ul");
                } else {
                    //
                    $(this).siblings(".sub-menu").slideDown();
                    $(this).parent().addClass("showing-ul");
                }

                e.preventDefault();
            }
        );

        //activete slick slider
        if ($(".top-slider").length > 0) {
            $(".top-slider").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                draggable: false,
                fade: true,
                arrows: true,
                autoplaySpeed: 3000,
                speed: 1250,
                lazyLoad: "ondemand",
            });

            $(".top-slider").on(
                "beforeChange",
                function (event, slick, currentSlide, nextSlide) {
                    var bg = jQuery(
                        '.top-slider [data-slick-index="' + nextSlide + '"]'
                    ).data("lazybgslide");
                    $('[data-slick-index="' + nextSlide + '"] .slide-img').css(
                        "background-image",
                        "url(" + bg + ")"
                    );
                }
            );
        }

        if (jQuery(".block-slider").length > 0) {
            var prevArrow =
                '<a type="button" class="slick-prev slick-arrow slick-arrow-white arrow-dark"></a>';
            var nextArrow =
                '<a type="button" class="slick-next slick-arrow slick-arrow-white arrow-dark"></a>';
            if ($(".page-template-template-custom-landing").length) {
                var prevArrow =
                    '<a type="button" class="slick-prev slick-arrow slick-arrow-white"></a>';
                var nextArrow =
                    '<a type="button" class="slick-next slick-arrow slick-arrow-white"></a>';
            }
            jQuery(".block-slider").each(function (index) {
                $(this).slick({
                    arrows: true,
                    dots: true,
                    infinite: true,
                    speed: 1200,
                    prevArrow: prevArrow,
                    nextArrow: nextArrow,
                    responsive: [
                        {
                            breakpoint: 9999,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });
            });
        }

        //foundation reveal
        var target = $(window.location.hash);
        if (target.length > 0 && target.hasClass("reveal")) {
            $(target).foundation("open");
        }
    });

    //init on load
    jQuery(window).on("load", function () {
        //start isotope
        if ($(".isotope-grid").length > 0) {
            var datatype = $("#reference-nav").attr("data-type");
            if (!datatype) {
                datatype = 'workshop_type';
            } 
            if (window.location.hash) {
                //sort by hashtag
                var hash = window.location.hash.substring(1);
                var filterName = "." + datatype + "-" + hash;
                jQuery(".isotope-grid").isotope({ filter: filterName });
                //add underline
                jQuery("#reference-nav a").removeClass("underline");
                jQuery('[data-sort-by="' + filterName + '"]').addClass(
                    "underline"
                );
            } else {
                setTimeout(function () {
                    jQuery(".isotope-grid").isotope({});
                }, 50);
            }
        }
    });

    //show or hide the top menu
    $(window).on("scroll load", function () {
        if ($(window).scrollTop() >= 50) {
            if (!$("body").hasClass("scrolled")) {
                $("body").addClass("scrolled");
                $("#main-menu-container").hide().fadeIn();
            }

            //reverse it back
        } else if ($(window).scrollTop() < 50) {
            if ($("body").hasClass("scrolled")) {
                $("body").removeClass("scrolled");
            }
        }
    });

    //isotope sorting
    jQuery("#reference-nav a").click(function (e) {
        e.preventDefault();

        var Myclass = $(this).attr("data-sort-by");

        jQuery(".isotope-grid").isotope({
            filter: Myclass,
        });

        //remove underline from all links
        jQuery("#reference-nav a").removeClass("underline");

        //add class
        jQuery(this).addClass("underline");

        //append hashtag
        var linkhash = $(this).attr("href");
        window.location.hash = linkhash;
    });

    /* https://css-tricks.com/slide-in-as-you-scroll-down-boxes/
    ================================================================== */

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *     the user visible viewport of a web browser.
     *     only accounts for vertical position, not horizontal.
     */

    $.fn.visible = function (partial, offset = 99999) {
        var $t = $(this),
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset().top - 100,
            _bottom = _top + $t.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return (
            compareBottom - offset <= viewBottom &&
            compareTop + offset >= viewTop
        );
    };

    /* Slide in function
    ==================================*/

    var win = $(window);
    var allUps = $(".slide-up");

    function AllClasses(classes, offset) {
        classes.each(function (i, el) {
            var el = $(el);
            if (el.visible(true, offset)) {
                if (!el.hasClass("already-visible")) {
                    el.addClass("come-in");
                }
            }
        });
    }

    function get_browser() {
        var ua = navigator.userAgent,
            tem,
            M =
                ua.match(
                    /(opera|yabrowser|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
                ) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { name: "IE", version: tem[1] || "" };
        }
        if (M[1] === "Chrome") {
            tem = ua.match(/\bOPR|Edge\/(\d+)/);
            if (tem != null) {
                return { name: "Opera", version: tem[1] };
            }
        }
        M = M[2]
            ? [M[1], M[2]]
            : [navigator.appName, navigator.appVersion, "-?"];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return {
            name: M[0],
            version: M[1],
        };
    }

    function iOSversion() {
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            if (!!window.indexedDB) {
                return 8;
            }
            if (!!window.SpeechSynthesisUtterance) {
                return 7;
            }
            if (!!window.webkitAudioContext) {
                return 6;
            }
            if (!!window.matchMedia) {
                return 5;
            }
            if (!!window.history && "pushState" in window.history) {
                return 4;
            }
            return 3;
        }

        return "";
    }

    const agent = window.navigator.userAgent;

    const botUserAgentsArray = [
                'googlebot',
                'bingbot',
                'linkedinbot',
                'mediapartners-google',
                'lighthouse',
                'insights',
    ];

    var isBotUserAgent = 0;
    for (var j = 0; j < botUserAgentsArray.length; j++){
        if (agent.toLowerCase().indexOf(botUserAgentsArray[j].toLowerCase()) !== -1){
            console.log("botUserAgent found: " + botUserAgentsArray[j].toLowerCase());
            isBotUserAgent = 1;
            break;
        }
    }

    if (isBotUserAgent == 1){
        $(".slide-up").removeClass('slide-up');
    } else {
        win.on("scroll load resize", function (event) {
            //slide in up
            AllClasses(allUps, 200);
        });
    
        //fix loading on reference page
        $("#reference-nav a").click(function () {
            setTimeout(function () {
                AllClasses(allUps, 9999999999);
            }, 10);
        });    
    }
    
   
    
    

    //add css script with js
    function append_no_flexbox() {
        document.querySelector("head").innerHTML +=
            '<link rel="stylesheet" href="https://www.flera.cz/wp-content/themes/flera/assets/styles/css-specific/noflexbox.css" type="text/css"/>';
    }

    $(document).ready(function () {
        //alert( get_browser().name + " " + get_browser().version );

        //select chrome under version 28
        if (
            get_browser().name == "Chrome" &&
            parseInt(get_browser().version) <= 28
        ) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-chrome")
                .addClass("no-flexbox");

            //append no flexbox css
            append_no_flexbox();
        }

        // Select Firefox under 28
        if (
            get_browser().name == "Firefox" &&
            parseInt(get_browser().version) <= 28
        ) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-firefox")
                .addClass("no-flexbox");

            //append no flexbox css
            append_no_flexbox();
        }

        // Select Safari under version 8
        if (
            get_browser().name == "Safari" &&
            parseInt(get_browser().version) <= 8
        ) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-safari")
                .addClass("no-flexbox");

            //append no flexbox css
            append_no_flexbox();
        }

        // Select IE under 10
        if (
            get_browser().name == "Msie" &&
            parseInt(get_browser().version) <= 10
        ) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-ie")
                .addClass("no-flexbox");

            //append no flexbox css
            append_no_flexbox();
        }

        //detect old IOS
        if (iOSversion() === 4 || iOSversion() === 3) {
            jQuery("html")
                .addClass("no-sliding")
                .addClass("old-iphone")
                .addClass("no-flexbox");

            //append no flexbox css
            append_no_flexbox();
        }
    });

    //double click on top menu functionality
    /**
     * jquery-doubleTapToGo plugin
     * Copyright 2017 DACHCOM.DIGITAL AG
     * @author Marco Rieser
     * @author Volker Andres
     * @author Stefan Hagspiel
     * @version 3.0.2
     * @see https://github.com/dachcom-digital/jquery-doubletaptogo
     */
    (function ($, window, document, undefined) {
        "use strict";
        var pluginName = "doubleTapToGo",
            defaults = {
                automatic: true,
                selectorClass: "doubletap",
                selectorChain: "li:has(ul)",
            };

        function DoubleTapToGo(element, options) {
            this.element = element;
            this.settings = $.extend({}, defaults, options);
            this._defaults = defaults;
            this._name = pluginName;
            this.init();
        }

        $.extend(DoubleTapToGo.prototype, {
            preventClick: false,
            currentTap: $(),
            init: function () {
                $(this.element)
                    .on(
                        "touchstart",
                        "." + this.settings.selectorClass,
                        this._tap.bind(this)
                    )
                    .on(
                        "click",
                        "." + this.settings.selectorClass,
                        this._click.bind(this)
                    )
                    .on("remove", this._destroy.bind(this));

                this._addSelectors();
            },

            _addSelectors: function () {
                if (this.settings.automatic !== true) {
                    return;
                }
                $(this.element)
                    .find(this.settings.selectorChain)
                    .addClass(this.settings.selectorClass);
            },

            _click: function (event) {
                if (this.preventClick) {
                    event.preventDefault();
                } else {
                    this.currentTap = $();
                }
            },

            _tap: function (event) {
                var $target = $(event.target).closest("li");
                if (!$target.hasClass(this.settings.selectorClass)) {
                    this.preventClick = false;
                    return;
                }
                if ($target.get(0) === this.currentTap.get(0)) {
                    this.preventClick = false;
                    return;
                }
                this.preventClick = true;
                this.currentTap = $target;
                event.stopPropagation();
            },

            _destroy: function () {
                $(this.element).off();
            },

            reset: function () {
                this.currentTap = $();
            },
        });

        $.fn[pluginName] = function (options) {
            var args = arguments,
                returns;
            if (options === undefined || typeof options === "object") {
                return this.each(function () {
                    if (!$.data(this, pluginName)) {
                        $.data(
                            this,
                            pluginName,
                            new DoubleTapToGo(this, options)
                        );
                    }
                });
            } else if (
                typeof options === "string" &&
                options[0] !== "_" &&
                options !== "init"
            ) {
                this.each(function () {
                    var instance = $.data(this, pluginName),
                        methodName =
                            options === "destroy" ? "_destroy" : options;
                    if (
                        instance instanceof DoubleTapToGo &&
                        typeof instance[methodName] === "function"
                    ) {
                        returns = instance[methodName].apply(
                            instance,
                            Array.prototype.slice.call(args, 1)
                        );
                    }
                    if (options === "destroy") {
                        $.data(this, pluginName, null);
                    }
                });
                return returns !== undefined ? returns : this;
            }
        };
    })(jQuery, window, document);

    $(function () {
        $(".header-menu").doubleTapToGo();
    });

    //guttenrg block sekce
    $(".wds-block .section-arrow").on("click", function () {
        var item = $(this);
        var parent = item.parents(".wds-block");
        var offset = 120;
        var topOffset =
            parent.position().top + parent.outerHeight(true) + offset;
        $("html, body").animate(
            {
                scrollTop: topOffset,
            },
            500
        );
    });

    //offset bloku na
    jQuery(document).on("ready", function () {
        resizeNewsletter();
    });
    jQuery(window).on("resize", function () {
        //setTimeout(function () {
        resizeNewsletter();
        //}, 100);
    });

    function resizeNewsletter() {
        var width = $(window).width();

        if (width > 0 && width !== undefined) {
            $(".wds-newsletter-section").each(function (el, index) {
                var news = $(this);
                var newsWidth = news.width();
                if (width < 1200) {
                    newsWidth = width - 20;
                }
                var offset = -((width - newsWidth) / 2);
                if (offset && width) {
                    $(this).css("width", width);
                    $(this).css("margin-left", offset);
                }
            });
        }
    }
})(jQuery);
